import { getKidAvatar } from "../../../utils/kidAvatar";

const kidInitialValue = {
  id: Date.now(),
  photo: getKidAvatar(),
  nom: "",
  prenom: "",
  adresseDto: {
    rue: "",
    ville: "",
    codePostale: 0,
    pays: "France"
  },
  dateNaissance: "2017-01-01",
  dateAdmission: "2019-01-01",
  poid: 0,
  sexe: "Masculin",
  taille: 0,
  days: {
    LUNDI: {
      disable: false,
      horaireDebutDto: "07:30",
      horaireFinDto: "18:30"
    },
    MARDI: { disable: false, horaireDebutDto: "07:30", horaireFinDto: "18:30" },
    MERCREDI: {
      disable: false,
      horaireDebutDto: "07:30",
      horaireFinDto: "18:30"
    },
    JEUDI: { disable: false, horaireDebutDto: "07:30", horaireFinDto: "18:30" },
    VENDREDI: {
      disable: false,
      horaireDebutDto: "07:30",
      horaireFinDto: "18:30"
    },
    SAMEDI: { disable: false, horaireDebutDto: "07:30", horaireFinDto: "18:30" }
  },
  parents: [
    {
      nom: "",
      prenom: "",
      email: "",
      usingKidAddress: false,
      adresseDto: {
        rue: "",
        ville: "",
        codePostale: 0,
        pays: "France"
      },
      dateNaissance: "",
      sexe: "Masculin",
      situation: "Marié",
      numeroTel: ""
    },
    {
      nom: "",
      prenom: "",
      email: "",
      usingKidAddress: false,
      adresseDto: {
        rue: "",
        ville: "",
        codePostale: 0,
        pays: "France"
      },
      dateNaissance: "",
      sexe: "Feminin",
      situation: "Marié",
      numeroTel: ""
    }
  ],
  tierceAutorisesDto: [
    {
      nom: "",
      prenom: "",
      numeroTel: "",
      lienDeParente: ""
    }
  ]
};

export default kidInitialValue;
